const font = ['Visuelt','t-star', 'Roboto', 'Helvectica Neue', 'Helvetica', 'Arial', 'sans-serif']
/* 
  name2 --> medium  
  name1 --> regular 
*/

const fontClasses = {
  fontSecondary: {
    fontFamily: font,
    fontSize: '14px',
    fontWeight: '400',
  },
  popUpBody1 : {
      fontFamily: font,
      fontSize: '12px',
      fontWeight: '400',
  },
  title1: {
    fontFamily: font,
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px'
  },
  webtitle1:{
    fontFamily: font,
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '24px'
  },
  title2: {
    fontFamily: font,
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px'
  },
  title3: {
    fontFamily: font,
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '24px'
  },
  title4: {
    fontFamily: font,
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px'
  },
  title5: {
    fontFamily: font,
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '24px'
  },
  body2: {
    fontFamily: font,
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '500'
  },
  body1: {
    fontFamily: font,
    fontSize: '12px !important',
    lineHeight: '16px',
    fontWeight: '400'
  },
  webBody1: {
    fontFamily: font,
    fontSize: '15px',
    lineHeight: '16px',
    fontWeight: '400'
  },
  caption: {
    fontFamily: ['t-star', ...font],
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.6px',
    textTransform: 'uppercase'
  },
  graphLabel2: {
    fontFamily: font,
    fontSize: '10px',
    lineHeight: '16px',
    fontWeight: '500'
  },
  graphLabel1: {
    fontFamily: font,
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '400'
  },
  SlotsTitle1: {
    fontWeight: '400',
    fontFamily: font,
    fontSize: '16px',
    lineHeight: '24px'

  },
  greySmallText: {
    fontFamily: font,
    fontSize: '10px',
    lineHeight: '16px',
    fontWeight: '400'
  },
}

export { fontClasses }